import { render } from "./TIJVideo.vue?vue&type=template&id=03aa89c2"
import script from "./TIJVideo.vue?vue&type=script&lang=js"
export * from "./TIJVideo.vue?vue&type=script&lang=js"

import exportComponent from "/Users/mateomateus/Documents/Rabinovici/hp-blueprint-presentation/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__